import React, { useState, useRef, useEffect } from 'react';
import { Grid, Menu } from 'semantic-ui-react';
import ActivityModalView from './ActivityModalView';
import './ActivityModalContent.css';
import { Link } from 'react-router';

const ActivityModalContent = ({
  reportId,
  newReport,
  commentsFileList,
  renderFiles,
  activeItem: initialActiveItem = 'sharedLog',
}) => {
  const [activeItem, setActiveItem] = useState(initialActiveItem);
  const [focusedTab, setFocusedTab] = useState(initialActiveItem);

  const sharedLogRef = useRef(null);
  const externalCommentsRef = useRef(null);
  const internalConvRef = useRef(null);

  const refMap = {
    sharedLog: sharedLogRef,
    externalComments: externalCommentsRef,
    internalConversation: internalConvRef,
  };
  useEffect(() => {
    setFocusedTab(initialActiveItem);
    const refToFocus = refMap[initialActiveItem];
    setTimeout(() => {
      if (
        refToFocus.current &&
        typeof refToFocus.current.focus === 'function'
      ) {
        refToFocus.current.focus();
      }
    }, 300);
  }, [initialActiveItem]);

  const views = ActivityModalView({
    reportId,
    newReport,
    commentsFileList,
    renderFiles,
  });

  const handleKeyDown = (e, key) => {
    if (e.key === 'Enter') {
      setActiveItem(key);
      setFocusedTab(key);
      const ref = refMap[key];
      if (ref.current && typeof ref.current.focus === 'function') {
        ref.current.focus();
      }
    }
  };

  const getTabClassName = key => {
    let className = 'activity-tab';
    if (activeItem === key) className += ' active';
    if (focusedTab === key) className += ' focused';
    return className;
  };

  const renderTab = (key, label, ref) => (
    <Menu.Item key={key} className={getTabClassName(key)} link as={Link}>
      <div
        ref={ref}
        tabIndex={0}
        onMouseDown={() => {
          setActiveItem(key);
          setFocusedTab(key);
        }}
        onClick={() => {
          setActiveItem(key);
          setFocusedTab(key);
          setTimeout(() => {
            if (ref.current && typeof ref.current.focus === 'function') {
              ref.current.focus();
            }
          }, 0);
        }}
        onFocus={() => setFocusedTab(key)}
        onBlur={() => setFocusedTab(null)}
        onKeyDown={e => handleKeyDown(e, key)}
      >
        {label}
      </div>
    </Menu.Item>
  );

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={4}>
          <Menu vertical role="menu" className="activity-tab-container">
            {renderTab('sharedLog', 'External Shared Log', sharedLogRef)}
            {renderTab(
              'externalComments',
              'External Comments',
              externalCommentsRef
            )}
            {renderTab(
              'internalConversation',
              'Internal Shared Log',
              internalConvRef
            )}
          </Menu>
        </Grid.Column>

        <Grid.Column width={12}>{views?.[activeItem] || null}</Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default ActivityModalContent;
